/*
 * @Author: DQL
 * @Date: 2022-04-27 16:37:48
 * @LastEditors: DQL
 * @LastEditTime: 2022-04-27 16:37:53
 * @Description: file content
 */
/*
 * @Author: DQL
 * @Date: 2022-04-27 16:30:15
 * @LastEditors: DQL
 * @LastEditTime: 2022-04-27 16:30:16
 * @Description: file content
 */
import axios from 'axios';
import config from '@/config.js';

// 弹窗是否已展示
let uploadNotificationShow = false;

// 关闭notification
const close = () => {
  uploadNotificationShow = false;
};

// 刷新页面
const onRefresh = (newHash) => {
  close();
  // 更新localStorage版本号信息
  window.localStorage.setItem(config.app.code + 'Version', newHash);
  // 刷新页面
  window.location.reload(true);
};

// 展示提示弹窗
const openNotification = ($alert, newHash) => {
  uploadNotificationShow = true;
  $alert('检测到系统当前版本已更新，请刷新后使用。', '版本更新提示', {
    confirmButtonText: '确认更新',
    showClose: false,
    callback: action => {
      onRefresh(newHash);
    }
  });
};

// 获取hash
export const getHash = ($alert, isAuto) => {
  // 如果提示弹窗已展示，就没必要执行接下来的检查逻辑了
  if (!uploadNotificationShow) {
    // 在 js 中请求首页地址，这样不会刷新界面，也不会跨域
    axios.get(`${window.location.origin}${window.location.pathname}index.html?time=${new Date().getTime()}`)
      .then(rsp => {
        // 匹配index.html文件中引入的js文件是否变化（具体正则，视打包时的设置及文件路径而定）
        let newHash = rsp.data && rsp.data.match(/js\/app.(.*).js/)[1].split('.js')[0];
        newHash = newHash || null;
        // 查看本地版本
        const oldHash = localStorage.getItem(config.app.code + 'Version');
        if (!oldHash) {
          console.log('未检测到新版！');
          // 如果本地没有版本信息（第一次使用系统），则直接执行一次额外的刷新逻辑
          onRefresh(newHash);
        } else if (newHash && newHash !== oldHash) {
          console.log('检测到新版！', newHash);
          if (isAuto) {
            onRefresh(newHash);
          } else {
            // 本地已有版本信息，但是和新版不同：需更新版本，弹出提示
            openNotification($alert, newHash);
          }
        }
      });
  }
};
